export { default } from './ExpansionPanel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ExpansionPanel/index.js
// module id = 323
// module chunks = 0